import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from "axios";
import { AppStorage } from "../../storage/AppStorage";
import { Auth } from "./service/Auth";

export class HttpHandle {
  private static instance: HttpHandle;
  protected axios: AxiosInstance;

  private constructor() {
    this.axios = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL, //Buscar a URL de acordo com o ambiente (dev, prod, homol). Setá-los em um arquivo de ambiente separado
    });

    this.setInterceptor();
  }

  public static getInstance() {
    if (!HttpHandle.instance) {
      HttpHandle.instance = new HttpHandle();
    }

    return HttpHandle.instance;
  }

  public getAxios() {
    return this.axios;
  }

  private setInterceptor(): void {
    this.axios.interceptors.request.use(
      async (config: AxiosRequestConfig) => {
        //Buscar token de autenticação no backend aqui
        const accessToken: string | undefined =
          await AppStorage.getAccessToken();
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${accessToken}`,
        };

        return config;
      },
      (err: AxiosError) => {
        return err;
      }
    );

    this.axios.interceptors.response.use(
      (response: AxiosResponse<Record<string, unknown>>) => {
        return response;
      },
      async (error: any) => {
        const previousRequest: any = error.config;
        const loginService: Auth = new Auth();
        if (previousRequest.url !== "Auth" && error.response) {
          if (error.response.status === 401 && !previousRequest.sent) {
            previousRequest.sent = true;
            try {
              const refreshToken: string | undefined =
                await AppStorage.getRefreshToken();
              const user: string | undefined = await AppStorage.getCookieByKey(
                "USER"
              );
              const refreshBody = {
                user: user?.replaceAll('"', ""),
                refreshToken: refreshToken,
                grantType: "refresh_token",
              };

              const rs: any = await loginService.postRefreshTokenAuth(
                refreshBody
              );
              if (
                rs.data.data.token !== undefined &&
                rs.data.data.refreshToken !== undefined
              ) {
                await AppStorage.saveToken(false, rs.data.data.token);
                await AppStorage.saveToken(true, rs.data.data.refreshToken);
              }
              previousRequest.headers[
                "Authorization"
              ] = `Bearer ${rs.data.token}`;
              return this.axios(previousRequest);
            } catch (error: any) {
              return Promise.reject(error);
            }
          }
        }
        return Promise.reject(error);
      }
    );
  }
}
